import { AccessRulesFormValues, UserGroupEntities } from "./types";

export const formatAccessRulePayload = (rules: AccessRulesFormValues["rules"]) =>
  rules.map(rule => {
    let entityValue = rule.entity;
    if (rule.entity_type === UserGroupEntities.QUERY_TAG && rule.key) {
      entityValue = `${rule.key}:${rule.entity}`;
    }

    return {
      entity_type: rule.entity_type,
      entity: entityValue,
      type: rule.match_type,
    };
  });

